// Tiny Web Audio API sfx helper — gentle, calm sounds only.

let _ctx = null;
function ctx() {
  if (typeof window === "undefined") return null;
  if (!_ctx) {
    const AC = window.AudioContext || window.webkitAudioContext;
    _ctx = AC ? new AC() : null;
  }
  return _ctx;
}

function playTone(freq, duration, { volume = 0.06, type = "sine", delay = 0 } = {}) {
  const c = ctx();
  if (!c) return;
  const now = c.currentTime + delay;
  const osc = c.createOscillator();
  const gain = c.createGain();
  osc.frequency.setValueAtTime(freq, now);
  osc.type = type;
  gain.gain.setValueAtTime(0, now);
  gain.gain.linearRampToValueAtTime(volume, now + 0.02);
  gain.gain.exponentialRampToValueAtTime(0.0001, now + duration);
  osc.connect(gain).connect(c.destination);
  osc.start(now);
  osc.stop(now + duration + 0.05);
}

export const sfx = {
  correct(enabled = true) {
    if (!enabled) return;
    playTone(660, 0.18);
    playTone(880, 0.22, { delay: 0.06 });
  },
  incorrect(enabled = true) {
    if (!enabled) return;
    playTone(320, 0.25, { volume: 0.04, type: "triangle" });
  },
  milestone(enabled = true) {
    if (!enabled) return;
    playTone(660, 0.12);
    playTone(880, 0.12, { delay: 0.08 });
    playTone(1040, 0.2, { delay: 0.16 });
  },
  celebrate(enabled = true) {
    if (!enabled) return;
    [523, 659, 784, 1046].forEach((f, i) =>
      playTone(f, 0.24, { delay: i * 0.11 })
    );
  },
};
